var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"dark-mode-switcher",attrs:{"href":"javascript:;","title":_vm.$t('changeContrast')}},[_c('IconContrastSvg',{on:{"click":function($event){$event.preventDefault();return _vm.darkModeToggle.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }